import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { CONFIG } from '@/infra/config';

i18n.use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init<HttpBackendOptions>({
        debug: process.env.VITE_NODE_ENV !== 'production',
        partialBundledLanguages: true,
        ns: [],
        resources: {},
        initImmediate: false,
        returnNull: false,
        fallbackLng: 'zh-TW',
        fallbackNS: 'translation',
        load: 'currentOnly',
        backend: {
            loadPath: CONFIG.HTTP_BASE + '/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            caches: ['cookie'],
        },
    });
